import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Chip, Stack, Button } from '@mui/material';
import { apiService } from '../../services/apiService';
import { useParams, Link as RouterLink } from 'react-router-dom';
import AdSlot from '../../components/Common/AdSlot';

const TagDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [tag, setTag] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!slug) return;
      setLoading(true);
      setError(null);
      try {
        const resp = await apiService.getTag(slug);
        if (cancelled) return;
        setTag(resp?.data || resp);
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Failed to load tag');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  const bills = Array.isArray(tag?.bills) ? tag.bills : [];

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
        <Typography variant="h4">{tag?.name || slug}</Typography>
        {tag?.slug && <Chip label={`/${tag.slug}`} />}
      </Stack>
      {tag?.description && (
        <Typography variant="body1" sx={{ mb: 2 }}>{tag.description}</Typography>
      )}

      {/* Ad Slot: contextual to tag */}
      <Box sx={{ my: 2 }}>
        <AdSlot slotId={`ad-tag-${slug}`} width={728} height={90} tags={[String(slug)]} pageType="tag-detail" />
      </Box>

      {error && <Typography color="error" variant="body2">{error}</Typography>}
      <Card>
        <CardContent>
          {loading ? (
            <Typography variant="body2" color="textSecondary">Loading…</Typography>
          ) : bills.length === 0 ? (
            <Typography variant="body2" color="textSecondary">No linked bills.</Typography>
          ) : (
            <List>
              {bills.map((b: any, idx: number) => (
                <ListItem key={idx} secondaryAction={
                  <Button component={RouterLink as any} to={`/bills/${b.congress}/${b.type || b.bill_type}/${b.number || b.bill_number}`} size="small">View</Button>
                }>
                  <ListItemText
                    primary={b.title || `${(b.type || b.bill_type || '').toUpperCase()} ${b.number || b.bill_number}`}
                    secondary={`Latest: ${b.latest_action_text || b.latestAction?.text || ''}`}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default TagDetail;
